import "../styles/helpers/resetNew.scss"
import "../styles/globals.scss"
import "../styles/helpers/animations.scss"
import "../styles/helpers/moving-objects.scss"

import "../styles/ui/style.scss"
import "../styles/ui/header.scss"

import "../styles/welcome.scss"

window.onscroll = function () {
	let header = document.getElementById("header")
	if (header) {
		if (document.body.scrollTop > 10 || document.documentElement.scrollTop > 10) {
			header.classList.add("scrolled")
		} else {
			header.classList.remove("scrolled")
		}
	}
}

const scrollElements = document.querySelectorAll("data-reveal")

let options = {
	threshold: 0, //0.1
}
const observer = new IntersectionObserver((entries) => {
	entries.forEach((entry) => {
		if (entry.isIntersecting) {
			entry.target.classList.add("animated")
			observer.unobserve(entry.target)
		}
	})
}, options)
